const State = {

    // FIELDS
    "name": "الاسم",
    "status": "الحالة",
    "search": "بحث",
    "country": "البلد",

    // PAGE HEADER
    "state": "الحالة",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_country": "الرجاء اختيار البلد",
    "error_status": "الرجاء اختيار الحالة",

    // TABLE HEADERF
    "table_name": "الاسم",
    "table_country": "الدولة",
    "table_status": "الحالة",

}

export default State;